var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMax = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M24.762 0C25.446 0 26 .554 26 1.238v23.524c0 .684-.554 1.238-1.238 1.238H1.238A1.238 1.238 0 0 1 0 24.762V1.238C0 .554.554 0 1.238 0zM21 3H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-1 4.5A1.5 1.5 0 0 1 21.5 9v11a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 20V9A1.5 1.5 0 0 1 6 7.5h14zm-4.372 3.672h-4.974a.2.2 0 0 0-.141.341l.931.931a.2.2 0 0 1 0 .283L8.9 15.273a.2.2 0 0 0 0 .283l2.545 2.545a.2.2 0 0 0 .283 0l2.546-2.545a.2.2 0 0 1 .283 0l.931.931a.2.2 0 0 0 .341-.141v-4.974a.2.2 0 0 0-.2-.2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMax);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/max.fc3ce82c21d6c57787a20ad1daf56a8d.svg";